import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-search\"><path fill=\"#15192A\" fill-opacity=\".32\" d=\"M7.132 12.264a5.101 5.101 0 0 0 3.141-1.083l2.82 2.82.907-.907-2.82-2.82a5.1 5.1 0 0 0 1.084-3.142A5.138 5.138 0 0 0 7.132 2 5.138 5.138 0 0 0 2 7.132a5.138 5.138 0 0 0 5.132 5.132Zm0-8.981a3.853 3.853 0 0 1 3.849 3.849 3.853 3.853 0 0 1-3.85 3.849 3.853 3.853 0 0 1-3.848-3.85 3.853 3.853 0 0 1 3.849-3.848Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol